import { render, staticRenderFns } from "./lkuMr.vue?vue&type=template&id=4f588ddc"
import script from "./lkuMr.vue?vue&type=script&lang=js"
export * from "./lkuMr.vue?vue&type=script&lang=js"
import style0 from "./lkuMr.vue?vue&type=style&index=0&id=4f588ddc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports